import React, { useMemo } from 'react';
import { Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Select from '@shared/v2/components/Select';

import useOrigins from '@/hooks/useOrigins';

const DepartingFrom = ({ value, originCodes, onSubmit }) => {
  const origins = useOrigins(originCodes);

  const options = useMemo(
    () => [
      { text: 'All locations', value: null },
      ...origins.map((o) => ({ text: o.name, value: o.code })),
    ],
    [origins],
  );

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      height="48px"
      whitespace="nowrap"
    >
      <Select
        id="departing-from"
        value={value || ''}
        options={options}
        disabled={origins.length === 0}
        onSelectedChange={onSubmit}
        placeholder="Flying from"
        prefix="From"
      />
    </Flex>
  );
};

DepartingFrom.propTypes = {
  value: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  originCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default DepartingFrom;
